import React from 'react';

export function useQuery() {
  return React.useMemo(
    () => new URLSearchParams(window.location.search),
    [window.location.search]
  );
}
